import { SET_VIDEO_FILE, SET_VIDEO_NAME, SET_USER_DATA } from "./mutation-types";
import { RecordState } from "./state";

export default {
    [SET_VIDEO_FILE]: (state: RecordState, videoFile) => {
        state.videoFile = videoFile;
    },

    [SET_VIDEO_NAME]: (state: RecordState, videoName) => {
        state.videoName = videoName;
    },

    [SET_USER_DATA]: (state: RecordState, userData) => {
        state.userFirstName = userData.firstName || "";
        state.userLastName = userData.lastName || "";
        state.userEmail = userData.email || "";
        state.userPhone = userData.phone || "";
        state.userVideoAgreement = userData?.videoAgreement;
    }
};
